import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { Stack } from "@mui/system";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../context/UserContext";
import { trackEventMatomo } from '../../helpers/matomo';
import { TabPanelProps } from "../../types/helpers/types";
import ManagesLegacy from "./ManagesLegacy";
import NewManages from "./NewManages";

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      style={{ width: '100%' }}
      role="tabpanel"
      hidden={value !== index}
      {...other}
    >
      {value === index && <Box width='100%' sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


export default function ManagesTabs() {
  const { userData } = useContext(UserContext);
  const { t } = useTranslation('translation');
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    trackEventMatomo('gestão de gerências', 'click', 'aba', newValue === 0 ? 'gerências legadas' : 'novas gerências');
    setValue(newValue);
  };

  return (
    <Stack minWidth='100%' width='100%' direction="column" justifyContent='flex-start' alignItems='flex-start' spacing={1}>
      <Tabs
        textColor="secondary"
        indicatorColor="secondary"
        value={value}
        onChange={handleChange}>
        <Tab label={t('Managements.legado')} {...a11yProps(0)} />
        {userData.gerenciaMigrada && <Tab label={t('Managements.novaGerencia')} {...a11yProps(1)} />}
      </Tabs>
      <CustomTabPanel value={value} index={0}>
        <ManagesLegacy />
      </CustomTabPanel>
      {userData.gerenciaMigrada && <CustomTabPanel value={value} index={1}>
        <NewManages />
      </CustomTabPanel>}
    </Stack>
  );
}
